import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    const result = await http.post(`/v1/item-pricing/update-dynamic-group-title`, payload)
    commit('UPDATE_GROUP_TITLE', {
      groupIdx: payload.groupIdx,
      newTitle: payload.newTitle
    })
    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/update-dynamic-group-title/index.js